"use client";
import {
  useCompositeItem
} from "../__chunks/QZLXIDNP.js";
import "../__chunks/NWCBQ4CV.js";
import "../__chunks/UH3I23HL.js";
import {
  useTabScopedContext
} from "../__chunks/4B73HROV.js";
import "../__chunks/3IEDWLST.js";
import "../__chunks/IB7YUKH5.js";
import "../__chunks/4UUKJZ4V.js";
import "../__chunks/KK7H3W2B.js";
import "../__chunks/SHA3WOPI.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/3ORBWXWF.js";
import "../__chunks/EKQEJRUF.js";
import {
  useEvent,
  useId
} from "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/tab/tab.ts
import { useCallback } from "react";
import { disabledFromProps, invariant } from "@ariakit/core/utils/misc";
var useTab = createHook(
  (_a) => {
    var _b = _a, {
      store,
      accessibleWhenDisabled = true,
      getItem: getItemProp
    } = _b, props = __objRest(_b, [
      "store",
      "accessibleWhenDisabled",
      "getItem"
    ]);
    const context = useTabScopedContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component."
    );
    const defaultId = useId();
    const id = props.id || defaultId;
    const dimmed = disabledFromProps(props);
    const getItem = useCallback(
      (item) => {
        const nextItem = __spreadProps(__spreadValues({}, item), { dimmed });
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [dimmed, getItemProp]
    );
    const onClickProp = props.onClick;
    const onClick = useEvent((event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented)
        return;
      store == null ? void 0 : store.setSelectedId(id);
    });
    const panelId = store.panels.useState(
      (state) => {
        var _a2;
        return (_a2 = state.items.find((item) => item.tabId === id)) == null ? void 0 : _a2.id;
      }
    );
    const selected = store.useState((state) => !!id && state.selectedId === id);
    props = __spreadProps(__spreadValues({
      id,
      role: "tab",
      "aria-selected": selected,
      "aria-controls": panelId || void 0
    }, props), {
      onClick
    });
    props = useCompositeItem(__spreadProps(__spreadValues({
      store
    }, props), {
      accessibleWhenDisabled,
      getItem,
      shouldRegisterItem: !!defaultId ? props.shouldRegisterItem : false
    }));
    return props;
  }
);
var Tab = createMemoComponent((props) => {
  const htmlProps = useTab(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  Tab.displayName = "Tab";
}
export {
  Tab,
  useTab
};
